import React from 'react';
import { Div } from '@kizi/core-components';
import { SkeletonBlock, SkeletonWrapper } from './index';

const SectionDivider = () => (
  <Div width="100%" height={1} backgroundColor="#D8D8D8" />
);
const RepeatableSection = ({ isLastSection }) => (
  <Div marginBottom={!isLastSection ? 25 : 0} width="100%">
    <SkeletonBlock width={70} height={15} marginBottom={15} />
    <SkeletonBlock width={180} height={15} marginBottom={15} />
    <SkeletonBlock width={140} height={15} marginBottom={25} />
    {!isLastSection && <SectionDivider />}
  </Div>
);

export const FilterSkeletonLayout = () => {
  return (
    <SkeletonWrapper direction="column" padding="30px">
      <Div marginBottom={25} width="100%">
        <Div display="flex" width="100%" justifyContent="space-between">
          <SkeletonBlock width={70} height={25} marginBottom={25} />
          <SkeletonBlock width={104} height={25} marginBottom={25} />
        </Div>
        <SkeletonBlock width={70} height={15} marginBottom={15} />
        <SkeletonBlock width={180} height={15} marginBottom={15} />
        <SkeletonBlock width={140} height={15} marginBottom={25} />
        <SectionDivider />
      </Div>
      {new Array(5).fill(null).map((_, index) => (
        <RepeatableSection key={`rs_${index}`} isLastSection={index === 4} />
      ))}
    </SkeletonWrapper>
  );
};
